import { appsettings } from "../../core";
import { EntityController } from "./entity";
import { ActionController } from "./services/action";
import { SeguridadController } from "./seguridad";
import { ImportadorController } from './importador';
import PaisRequisitoService from "./services/paisrequisito";
import ReportesServiceOld from "./services/reporte";
import ResourceService from "./services/resource";
import { CobranzaService } from "./services/controllers/CobranzaService";
import { ProductosService } from "./services/controllers/ProductosService";
import { OperacionesService } from "./services/controllers/OperacionesService";
import { NotificacionesService } from "./services/controllers/NotificacionesService";
import { ClientesService } from "./services/controllers/ClientesService";
import { SeguridadService } from "./services/controllers/SeguridadService";
import { ReportesService } from "./services/controllers/ReportesService";
import { ComunicacionService } from "./services/controllers/ComunicacionService";

class APIService {
  entity = () => new EntityController((appsettings as any)[window.app_enviroment ?? 'production'].api.url);
  
  action = () => new ActionController((appsettings as any)[window.app_enviroment ?? 'production'].api.url);

  seguridad = () => new SeguridadController((appsettings as any)[window.app_enviroment ?? 'production'].api.url);
  
  importador = () => new ImportadorController((appsettings as any)[window.app_enviroment ?? 'production'].api.url);
  
  private _reportes : ReportesServiceOld | undefined = undefined;
  reportes = () => this._reportes = (this._reportes ?? new ReportesServiceOld((appsettings as any)[window.app_enviroment ?? 'production'].api.url));
  
  private _resource : ResourceService | undefined = undefined;
  resource = () => this._resource = (this._resource ?? new ResourceService((appsettings as any)[window.app_enviroment ?? 'production'].api.url));



  /** quedaron en la mongo */    
  private _paisrequisito : PaisRequisitoService | undefined = undefined;
  paisrequisito = () => this._paisrequisito = (this._paisrequisito ?? new PaisRequisitoService((appsettings as any)[window.app_enviroment ?? 'production'].api.url));

  // REING
  private _cobranza : CobranzaService | undefined = undefined;
  CobranzaController = () => this._cobranza = (this._cobranza ?? new CobranzaService((appsettings as any)[window.app_enviroment ?? 'production'].api.url));
  
  private _comunicacionService : ComunicacionService | undefined = undefined;
  ComunicacionController = () => this._comunicacionService = (this._comunicacionService ?? new ComunicacionService((appsettings as any)[window.app_enviroment ?? 'production'].api.url));

  private _productos : ProductosService | undefined = undefined;
  ProductosController = () => this._productos = (this._productos ?? new ProductosService((appsettings as any)[window.app_enviroment ?? 'production'].api.url));

  private _operaciones : OperacionesService | undefined = undefined;
  OperacionesController = () => this._operaciones = (this._operaciones ?? new OperacionesService((appsettings as any)[window.app_enviroment ?? 'production'].api.url));

  private _notificacionesService : NotificacionesService | undefined = undefined;
  NotificacionesController = () => this._notificacionesService = (this._notificacionesService ?? new NotificacionesService((appsettings as any)[window.app_enviroment ?? 'production'].api.url));

  private _clienteService : ClientesService | undefined = undefined;
  ClientesController = () => this._clienteService = (this._clienteService ?? new ClientesService((appsettings as any)[window.app_enviroment ?? 'production'].api.url));

  private _seguridadService : SeguridadService | undefined = undefined;
  SeguridadController = () => this._seguridadService = (this._seguridadService ?? new SeguridadService((appsettings as any)[window.app_enviroment ?? 'production'].api.url));

  private _reportesService : ReportesService | undefined = undefined;
  ReportesController = () => this._reportesService = (this._reportesService ?? new ReportesService((appsettings as any)[window.app_enviroment ?? 'production'].api.url));

}

const API = new APIService();
export default API;